import { MUITab } from "@abb/arcadia-ui-react"
import { useHashTab } from "../../../hooks/useHashTab"
import { Trainings } from "./trainings_tab/Trainings"

const TRAININGS_TAB_ID = "trainings"

export function TrainingsContainer() {
  const { activeTab, handleTabChange } = useHashTab(TRAININGS_TAB_ID)

  return (
    <div>
      <MUITab
        tabItems={[{ id: TRAININGS_TAB_ID, label: "Trainings" }]}
        value={activeTab}
        handleChange={handleTabChange}
      />
      {activeTab === TRAININGS_TAB_ID && <Trainings />}
    </div>
  )
}
